import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";

function DeleteFolderDialog({ open, folderName, onCancel, onConfirm }) {
  const [inputValue, setInputValue] = useState("");
  const [confirmEnabled, setConfirmEnabled] = useState(false);

  useEffect(() => {
    setInputValue("");
    setConfirmEnabled(false);
  }, [open]);

  useEffect(() => {
    setConfirmEnabled(inputValue === folderName);
  }, [inputValue, folderName]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleCancel = () => {
    onCancel();
  };

  const handleConfirm = () => {
    if (confirmEnabled) {
      onConfirm();
    }
  };

  return (
    <Dialog open={open} onClose={handleCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Delete Folder</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete the folder{" "}
          <Typography component="span" color="error">
            {folderName}
          </Typography>
          ? This action cannot be undone. Please type the folder name to
          confirm.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          label="Folder Name"
          fullWidth
          variant="outlined"
          value={inputValue}
          onChange={handleInputChange}
          autoComplete="off"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          color="error"
          variant="contained"
          disabled={!confirmEnabled}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteFolderDialog;
